"use strict";
import $ from 'jquery'

$(() => {
    $('.fab-menu').on('click', (e) => {
        const target = $(e.target);
        const expand = target.is('.fab-menu-toggle') || target.closest('.fab-menu-toggle').length > 0;
        $(e.currentTarget).toggleClass('active', expand);
    });
});
